import { render, staticRenderFns } from "./bubbleClockDesign.vue?vue&type=template&id=8023ee6c&scoped=true"
import script from "./bubbleClockDesign.vue?vue&type=script&lang=js"
export * from "./bubbleClockDesign.vue?vue&type=script&lang=js"
import style0 from "./bubbleClockDesign.vue?vue&type=style&index=0&id=8023ee6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8023ee6c",
  null
  
)

export default component.exports